import React from 'react'
import isEmpty from 'lodash/isEmpty'
import trim from 'lodash/trim'
import type { FetchResult } from '@apollo/client'
import { Field, FormModal } from '@ztechapps/webui.form'
import { TextInput } from '@ztechapps/webui.input'

export type BlogCategoryNameModalProps = {
  show: boolean
  title: string
  initialName?: string
  /** Persists the trimmed name; the modal closes once the result carries no errors, and stays open otherwise. */
  onSave: (name: string) => Promise<FetchResult>
  onClose: () => void
}

type BlogCategoryNameValues = { name: string }

export const BlogCategoryNameModal = ({
  show,
  title,
  initialName = '',
  onSave,
  onClose,
}: BlogCategoryNameModalProps) => {
  const save = async ({ name }: BlogCategoryNameValues) => {
    const result = await onSave(trim(name))
    if (isEmpty(result?.errors)) {
      onClose()
      return undefined
    }
    // A result that carries errors goes back to the form, which reports them and keeps the modal open.
    return result
  }

  return (
    <FormModal<BlogCategoryNameValues>
      show={show}
      onHide={onClose}
      onReset={onClose}
      size="md"
      trigger={() => null}
      title={title}
      saveText="Save"
      initialValues={{ name: initialName }}
      validate={({ name }) => (isEmpty(trim(name)) ? { name: 'Name is required' } : {})}
      onSubmit={save}
    >
      <Field name="name" label="Name" component={TextInput} />
    </FormModal>
  )
}
